import { useEffect } from "react";

const SITE = "Trippy Tastic";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

/** Per-page Google title, description and canonical link (Google runs the site's JavaScript). */
export function useSeo({ title, description, path }) {
  useEffect(() => {
    if (!title) return;
    const full = title.includes(SITE) ? title : `${title} | ${SITE}`;
    const url = `${window.location.origin}${path ?? window.location.pathname}`;
    document.title = full;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    setMeta("property", "og:title", full);
    setMeta("property", "og:url", url);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
  }, [title, description, path]);
}
